/*
 * Mapeamento de "Origem do Pedido" da Ação 143 (Políticas Comerciais) do ERP —
 * usado pela função de banco get_politica/get_desconto_politica para filtrar
 * quais políticas comerciais de desconto são elegíveis por canal de venda.
 *
 * O B2B é sempre OrigemPedido.B2B — o app é um build único para esse canal, não
 * há necessidade de configuração em runtime (chamado #72779).
 */
export enum OrigemPedido {
    INTERNO = '1',
    AFV = '2',
    B2B = '3',
    B2C = '4',
}
